import React, { useState  } from 'react';

import { useTheme } from '@mui/material/styles';

import Styled from 'components/Styled/Styled';
import {ControlBanner} from './components/ControlBanner/ControlBanner';
import {ImageProvider} from './components/ImageContext/ImageContext';
import {Image} from './components/Image/Image';
import {Magnifier} from './components/Magnifier/Magnifier';
import {Highlights} from './components/Highlights/Highlights';
import {emit} from 'api/prokey/prokey.websocket';

//-----------------------------------------------------------------
export function PanelAnalyticsImage( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES] === STATE

  const { is_comp } = props;

  const theme = useTheme();

  const [ settings, setSettings ] = useState({})

  const _styles = {
    container: {
      width      : '100%'     ,
      position   : 'static' ,
      height     : 'calc( 100% )' ,
      background : theme.palette.background.secondary[theme.palette.mode],
    },
  }

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  function onChange_Settings() {

  }
  
  //-----------------------------------------------------------------
  function onMouseUp() {
    //-----------------------------------------------------------------
    const type = is_comp ? 'FILE_COMPARISON_FIELD_FOCUS' : 'FILE_FIELD_FOCUS';
    emit( type );
  }

  //#endregion 

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Styled styles={[_styles.container]} onMouseUp={onMouseUp}>
        <ImageProvider is_comp={is_comp} >
          <ControlBanner onChange={setSettings} />
          <Styled styles={[{ position :'relative'}, { height: 'calc( 100% - 60px )' }, { cursor: 'crosshair' }, { overflow:'auto' }, { marginTop: '6px' } ]}>
            <Image      settings={settings} is_comp={is_comp} />
            <Highlights settings={settings} is_comp={is_comp} />
            <Magnifier  settings={settings} is_comp={is_comp} />
          </Styled>
        </ImageProvider>
      </Styled>
    )
  }

  //#endregion
  
  return display();
}